export { default } from './legalNavigation';
